import { createTheme } from '@mui/material/styles';
import palette from './palette';
import dimensions from './dimensions';
import components from './components';

// A theme per mode rather than one theme with a switch inside it: MUI decides a great deal from
// palette.mode alone — default text colours, paper elevation, divider strength — and it can only
// do that if the mode is part of the theme it is given.
export const buildTheme = (mode = 'light') => createTheme({
  palette: palette(mode),
  dimensions,
  components: components(mode),
});

export default buildTheme('light');
